import React, { useEffect, useState } from 'react';
import storage from 'local-storage-fallback';
import { Button, Banner, Text, Box } from '@freenow/wave';
import { CookieEmoji } from '../CookieEmoji/CookieEmoji';
import { CookieInformationText } from '../CookieInformationText/CookieInformationText';
import { getLatestDecision } from '../../util/getLatestDecision';
import { COOKIE_STATE } from '../../types/CookieState';
export const COOKIES_ACCEPTANCE_TIMESTAMP_KEY = 'mytaxi/react-cookie-banner/cookies-acceptance-timestamp';
export const COOKIES_REJECTION_TIMESTAMP_KEY = 'mytaxi/react-cookie-banner/cookies-rejection-timestamp';
export const CookieBanner = ({ informationText, confirmationText, cancelText, link, cookieStateCallback, }) => {
    const [decision, setDecision] = useState();
    useEffect(() => {
        const initialDecision = getLatestDecision();
        switch (initialDecision) {
            case COOKIE_STATE.ACCEPTED:
                triggerCookieStateCallback(initialDecision);
                setDecision(COOKIE_STATE.ACCEPTED);
                break;
            case COOKIE_STATE.REJECTED:
                triggerCookieStateCallback(initialDecision);
                setDecision(COOKIE_STATE.REJECTED);
                break;
            default:
                triggerCookieStateCallback(initialDecision);
                setDecision(COOKIE_STATE.UNKNOWN);
                break;
        }
    }, []);
    const triggerCookieStateCallback = (currentCookieState) => {
        if (cookieStateCallback) {
            cookieStateCallback(currentCookieState);
        }
    };
    const acceptCookies = () => {
        storage.setItem(COOKIES_ACCEPTANCE_TIMESTAMP_KEY, Date.now().toString());
        triggerCookieStateCallback(COOKIE_STATE.ACCEPTED);
        setDecision(COOKIE_STATE.ACCEPTED);
    };
    const rejectCookies = () => {
        storage.setItem(COOKIES_REJECTION_TIMESTAMP_KEY, Date.now().toString());
        triggerCookieStateCallback(COOKIE_STATE.REJECTED);
        setDecision(COOKIE_STATE.REJECTED);
    };
    if (!decision || decision !== COOKIE_STATE.UNKNOWN) {
        return null;
    }
    return (React.createElement(Banner, { position: "top" }, (dismiss) => (React.createElement(Box, { display: "flex", maxWidth: "1024px", flexDirection: { _: 'column', medium: 'row' }, mx: "auto" },
        React.createElement(Text, { "data-testid": "cookie-text" },
            React.createElement(CookieEmoji, null),
            React.createElement(CookieInformationText, { informationText: informationText, link: link })),
        React.createElement(Box, { display: "flex", flexDirection: { _: 'column', medium: 'row' }, ml: { _: 0, medium: 1 }, mt: { _: 1, medium: 0 } },
            cancelText && (React.createElement(Button, { width: { _: '100%', medium: 'auto' }, variant: "secondary", mr: { _: 0, medium: 1 }, "data-testid": "cancel-button", onClick: () => {
                    rejectCookies();
                    dismiss();
                } }, cancelText)),
            React.createElement(Button, { width: { _: '100%', medium: 'auto' }, mt: { _: 1, medium: 0 }, "data-testid": "confirmation-button", onClick: acceptCookies }, confirmationText))))));
};
